import { i18n } from "translate/i18n";

export const weekDayName = (weekDay) => i18n.t(`messages.week.${weekDay}`);
export const dayTranslate = i18n.t("messages.planChecklist.day");

export const buildReadingDate = (weekDay, dayTranslate, dayNumber) =>
  `${weekDayName(weekDay)} ${dayTranslate} ${dayNumber}`;
